import './zoomimg.less'

import {DOMAttrs, m} from '@codeurs/front'
import {
	FunctionComponent,
	useCallback,
	useLayoutEffect,
	useRef,
	useState
} from 'react'
import posed from 'react-pose'
import {Img} from './img'
import {style} from './style'
import {isIE} from './tools'

const transition = {
	duration: 400,
	ease: [0.08, 0.69, 0.2, 0.99]
}

const Frame = posed.div({
	init: {
		applyAtEnd: {display: 'none'},
		opacity: 0,
		transition
	},
	zoom: {
		applyAtStart: {display: 'block'},
		opacity: 1,
		transition
	}
})
const Image = posed(Img)({
	init: {
		applyAtEnd: {zIndex: 0},
		opacity: 1,
		position: 'relative',
		height: 'auto',
		width: '100%',
		maxWidth: '100%',
		transition,
		flip: true
	},
	zoom: {
		applyAtStart: {zIndex: 8},
		position: 'fixed',
		width: 'auto',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		transition,
		flip: true,
		opacity: 1
	}
})
const styles = style('zoomimg')

export const ZoomImg: FunctionComponent<
	{
		zoomed?: boolean
		setZoomed?: (zoomed: boolean) => void
		width: number
		height: number
		customwidth: string
		customheight: string
		imagetextblock?: boolean
	} & DOMAttrs
> = props => {
	const internal = useState(false)
	const {imagetextblock, zoomed = internal[0], setZoomed = internal[1]} = props
	const {height, customwidth, customheight, alt, ...rest} = props

	let {width} = props
	const pose = zoomed ? 'zoom' : 'init'
	const container = useRef<HTMLDivElement>()
	const image = useRef<HTMLImageElement>()
	const resetRef = useRef(null)
	if (customwidth) width = Number(customwidth)

	const toggleZoom = useCallback(
		isZoomed => {
			if (resetRef.current) {
				clearTimeout(resetRef.current)
			}
			if (isZoomed) {
				container.current.style.width = image.current.clientWidth + 'px'
				container.current.style.height = image.current.clientHeight + 'px'
				image.current.style.opacity = '1'
			} else {
				resetRef.current = setTimeout(() => {
					if (!container.current) return null
					container.current.style.maxWidth = width ? width + 'px' : '100%'
					container.current.style.width = '100%'
					if (imagetextblock) container.current.style.width = width + 'px'
					container.current.style.width = '100%'
					container.current.style.height =
						customheight !== '' ? customheight + 'px' : 'auto'
					image.current.style.height =
						customheight !== '' ? customheight + 'px' : 'auto'
					image.current.style.opacity = '1'
				}, 400)
			}
			setZoomed(isZoomed)
		},
		[setZoomed]
	)

	useLayoutEffect(() => {
		const zoomOut = () => toggleZoom(false)
		window.addEventListener('scroll', zoomOut)
		return () => window.removeEventListener('scroll', zoomOut)
	}, [zoomed])

	const {class: className} = props
	if (imagetextblock && width > 400) width = 400
	return (
		<div
			ref={container}
			style={{
				maxWidth: isIE ? null : width ? width + 'px' : '100%',
				width: '100%',
				minWidth: imagetextblock && width + 'px'
			}}
			class={styles}
			onClick={() => toggleZoom(!zoomed)}
		>
			<Frame pose={pose} {...styles('frame')} />
			<Image
				ref={image}
				pose={pose}
				className={
					styles('img').is({zoomed}) +
					(!zoomed && className ? ' ' + className : '')
				}
				src={rest.src}
				style={{
					width: '100%',
					height: customheight !== '' ? customheight + 'px' : 'auto',
					opacity: 1
				}}
			/>
			{alt && <span className={styles('copyright')}>{alt}</span>}
		</div>
	)
}
